import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Heading, Text } from "grommet";
import * as React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { usePermission } from "../account/AccountStore";
import CustomButton from "../components/CustomButton";
import SkeletonWrapper from "../components/SkeletonWrapper";
import CreateLeague from "./CreateLeague";
import LeagueProfile from "./LeagueProfile";
import { LeagueRow } from "./LeagueRow";
import { getLeagues, LeagueViewModel } from "./LeaguesStore";

export const newLeagueIcon = (
    <span className="fa-layers fa-fw">
        {/* @ts-ignore */}
        <FontAwesomeIcon size="lg" icon={["fad", "trophy"]}></FontAwesomeIcon>
        <FontAwesomeIcon icon={["fad", "plus"]} swapOpacity transform="up-15 right-15" />
    </span>
);

/* @ts-ignore */
const archive = <FontAwesomeIcon size="xl" icon={["fad", "archive"]}></FontAwesomeIcon>;

const LeaguesManagement = () => {
    const [leagues, setLeagues] = React.useState([] as LeagueViewModel[]);
    let { pathname } = useLocation();

    const [loading, setLoading] = React.useState(true);
    const [showArchive, setShowArchive] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        getLeagues(showArchive).then((leagues) => {
            setLeagues(leagues);
            setLoading(false);
        });
    }, [pathname, showArchive]);

    const hasWritePermission = usePermission("sport:leagues.write");

    return (
        <div>
            <Routes>
                <Route path={"create"} element={<CreateLeague />}></Route>
                <Route path={":leagueID/*"} element={<LeagueProfile />}></Route>
                <Route
                    path={""}
                    element={
                        <>
                            <Heading size="small">Leagues</Heading>
                            <Box direction="row" pad={"small"} gap="small">
                                {hasWritePermission && <CustomButton path={"/leagues/create"} icon={newLeagueIcon} label="New League"></CustomButton>}
                                <CustomButton icon={archive} primary={showArchive} label={showArchive ? "Show Active" : "Show Archive"} onClick={() => setShowArchive(!showArchive)}></CustomButton>
                            </Box>
                            <Box gap="small">
                                <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                                    Leagues
                                </Text>
                                <SkeletonWrapper loading={loading}>
                                    <Box gap="small">
                                        {leagues.map((league) => (
                                            <LeagueRow key={league.id} league={league}>
                                                <></>
                                            </LeagueRow>
                                        ))}
                                    </Box>
                                </SkeletonWrapper>
                            </Box>
                        </>
                    }
                ></Route>
            </Routes>
        </div>
    );
};

export default LeaguesManagement;
